<script setup>
import combinationStorage from '@/services/combination-storage';
import { defineOptions, ref } from 'vue';

defineOptions({
  name: 'CombinationProductFlow'
});

const flowTitleArr = ref(['挑選兩端產品', '選擇線材款式', '選擇串接方式', '確認訂單']);
</script>

<template>
  <section class="c-combination-title py-5">
    <div class="container-fluid">
      <div class="row">
        <div class="col">
          <h1 class="h3 text-center mb-4">客製化組裝</h1>
          <ol class="d-none d-lg-flex justify-content-center gap-3">
            <li v-for="(flow, idx) in flowTitleArr" :key="flow" class="d-flex align-items-center gap-2">
              <span class="badge fs-6"
                :class="idx === combinationStorage.flowIndex ? 'bg-primary' : 'bg-secondary'"
                v-if="idx >= combinationStorage.flowIndex">{{ idx + 1 }}</span>
              <span class="badge fs-6"
                :class="idx === combinationStorage.flowIndex ? 'bg-primary' : 'bg-secondary'"
                v-else><i class="fa-regular fa-check"></i></span>
              {{ flow }}
            </li>
          </ol>
          <p class="mb-0 d-lg-none text-center">
            <span class="badge bg-primary fs-6 d-lg-none me-2">步驟{{ combinationStorage.flowIndex + 1 }}</span>
            {{ flowTitleArr[combinationStorage.flowIndex] }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>

</style>
